import React, { useState } from "react";
import styles from "./StudentMonthlyAttendanceView.module.css";
import Dropdown from "../../components/Dropdown/Dropdown";
import TabSelector from "../../components/TabSelector/TabSelector";
import SearchBar from "../../components/SearchBar/SearchBar";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import IconAndLabel from "../../components/IconAndLabel/IconAndLabel";
// Check in/out icons
import { IoMdCloseCircleOutline } from "react-icons/io"; 
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";




const StudentMonthlyAttendanceView = () => {
 
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);
  const dispatch = useDispatch();


 


  const data = [
    {
      _id: "s1",
      studentName: "John Jacob",
      room: "Room 1",
      present: "9:00 AM By Darshan",
      absent: "5:00 PM By Darshan",
      leave: "Sick Leave",
      presentpercent: "75%",
    },
    { _id: "s2", studentName: "John Jacob" },
    { _id: "s3", studentName: "John Jacob" },
    { _id: "s4", studentName: "John Jacob" },
    { _id: "s5", studentName: "John Jacob" },
  ];




  const getColumnData = (data) => {
    return data?.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        studentName: <LogoWithName name={item.studentName} />,
        room: item.room || "-",
        
        present:item.present||"-",
        absent:item.absent||"-",
        leave:item.leave||"-",
        presentpercent:item.presentpercent||"-",

      
        
        
      };
    });
  };
  const columnData = getColumnData(data);

  const handleDownloadExcel = () => {
    const formattedData = data.map((item) => ({
      "Student Name": item.studentName || "-",
      Room: item.room || "-",
      Present: item.present || "-",
      Absent: item.absent || "-",
      Leave: item.leave || "-",
      "Present Percentage": item.presentpercent || "-",
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(blob, "Student_Monthly_Attendance.xlsx");
  };

  
  const headings = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Student Name", accessor: "studentName" },
    { title: "Room", accessor: "room" },
    { title: "Present", accessor: "present" },
    { title: "Absent", accessor: "absent" },
    { title: " Leave", accessor: "leave" },
    { title: "Present Percentage", accessor: "presentpercent" },
  ];

  

  return (
    <div className={styles.wrapper}>
      

      <div className={styles.totaltable}>
        <div className={styles.controlsBar}>
          <div className={styles.search}>
            <SearchBar
              placeholder="Search Program"
              onChange={(e) => console.log(e.target.value)}
            />
          </div>
          <div className={styles.rightrow}>
            <button
              onClick={handleDownloadExcel}
              className={styles.downloadBtn}
            >
              Download Excel
            </button>
          </div>
        </div>

        <div className={styles.tableBox}>
          <Dynamic
            headings={headings}
            columnData={columnData.slice(
              (currentPage - 1) * itemsPerPage,
              currentPage * itemsPerPage
            )}
          />
          <PaginationTable
            data={columnData}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            setCurrentPage={setCurrentPage}
            setItemsPerPage={setItemsPerPage}
          />
        </div>
      </div>
    </div>
  );
};

export default StudentMonthlyAttendanceView;
